import React from 'react'
import { Container, Dropdown, DropdownButton } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import iconLogo from '../../../assets/logos/iconLogo.svg'
import userIcon from '../../../assets/icons/user-icon.svg'
import signoutIcon from '../../../assets/icons/signout-icon.svg'
import './style.sass'

const TopNavBar = () => {  
  // ===== Hooks =====
  const history = useHistory()

  // ===== Redux state =====
  const session = useSelector(({ auth }) => auth.session)

  // ===== Methods =====
  const onSignOutClicked = () => {
    history?.push('/logout-callback')
  }

  const renderUserDropdown = () => {
    return (
      <DropdownButton
        title={<img src={userIcon} alt="user" />}
        className='user-dropdown'
      >
        <Dropdown.Item eventKey="1" className='user-name'>
          {session?.profile?.email}
        </Dropdown.Item>
        <Dropdown.Item eventKey="2" onClick={onSignOutClicked}>
          <img src={signoutIcon} alt="signOut"/> Sign out
        </Dropdown.Item>
      </DropdownButton>
    )
  }

  return (
    <div className="top-nav-bar-component-container">
      <Container>
        <div className="left-section">
          <img className="logo-image" src={iconLogo} alt='iconLogo' />
          <label><span>Softrig</span> Management UI</label>
        </div>
        <div className="right-section">
          {renderUserDropdown()}
        </div>
      </Container>
    </div>
  )
}

export default TopNavBar